/**
 * registerPasskey ceremony (Req 11.2)
 *
 * 3 phase: register-options → bridge.create (navigator.credentials.create) → register-verify。
 * ApiClient が HTTP error を `AuthError` として surface するため、ここでは再ラップしない。
 */
/**
 * passkey credential を登録し、登録済みサマリを返す。
 *
 * @param apiClient `@auth/client` の ApiClient (inject 経由)
 * @param webAuthnBridge WebAuthn ceremony seam
 * @param input `{ label? }`
 */
export async function registerPasskey(apiClient, webAuthnBridge, input) {
    const label = input?.label;
    const options = await apiClient.post("/auth/passkey/register-options", { label });
    const attestation = await webAuthnBridge.create(options);
    const summary = await apiClient.post("/auth/passkey/register-verify", {
        challengeToken: options.challengeToken,
        attestation,
        label,
    });
    return summary;
}
//# sourceMappingURL=register-ceremony.js.map